import timer from '@devices/settings/device_settings/timer.js';
import schedule from '@devices/settings/device_settings/schedule.js';
import night_mode from '@devices/settings/device_settings/night_mode.js';
import actions from '@devices/settings/device_settings/actions.js';
import internet from '@devices/settings/device_settings/internet.js';
import app_setting_plus_rgbw_gen_2 from '@devices/settings/common_settings/app_setting_plus_rgbw_gen_2.js';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'shellydimmer2',
	friendly_name: 'Dimmer 2',
	family: 'light',
	isPM: true,
	modes: {
		white: {
			availableViews: ['basic'],
			channels: 1,
			notifications: ['offline', 'device_problem', 'forgotten_lights', 'overtemperature'],
			color: false,
			color_temp: false,
			effects: false,
			slider: 'brightness',
			brightness: 1,
			settings: [
				timer,
				schedule,
				night_mode,
				actions,
				internet,
				app_setting_plus_rgbw_gen_2,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode' },
						{ title: 'power_on_default', component: 'power_on_default_rr' },
						{ title: 'button_type', component: 'button_type' },
						{ title: 'dimmer_calibration', component: 'dimmer_calibration' },
						{ title: 'button_debounce', component: 'button_debounce' },
						{ title: 'transition_time', component: 'transition_time' },
						{ title: 'buttons_fade_rate', component: 'buttons_fade_rate' },
						{ title: 'minimum_brightness', component: 'min_brightness' },
						{
							title: 'antiflickering_debounce',
							component: 'antiflickering_debounce',
						},
						{ title: 'warm_up', component: 'warm_up', min_ver: '1.9.0' },
						{ title: 'led_status_disable', component: 'led_status_disable' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'device_name', component: 'device_name' },
						{ title: 'channel_name', component: 'channel_name' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
